export class PermissionError extends Error {}

export class NotFoundError extends Error {}

export class NetworkError extends Error {}
